import React from "react";
import "./style.scss";

const NotifBadge = ({ num }) => {
  return (
    <span className="notif_badge">
      <span className="notif_badge_container">
        <span className="notif_badge_num">{num > 99 ? "99+" : num}</span>
      </span>
    </span>
  );
};

export default NotifBadge;
